import PageDescriptionFootnote from "../Footnote";

const PageDescriptionAtracao = (props: any) => {

    function renderObjectBody(data: any) {
        return { __html: data }
    }

    return (

        <section className="page-description mb-9">
            <div className="container">
                <div className="row justify-content-center">

                    {props.items?.filter((i: { Identificador: any; }) => i.Identificador === props.page).map((item:
                        { Corpo: any; }) => (
                        <div className="col-lg-10">
                            <div className="page-description__desc mb-7 mb-lg-9">
                                <div className="d-md-flex justify-content-between align-items-center">
                                    <div className="tittle">
                                        <h3 className="mb-4 mb-md-0"> Força Laranja </h3>
                                        <p className="d-md-none">
                                            Você pode visualizar todas as oportunidades abertas diretamente em nossa página na Gupy.
                                        </p>
                                    </div>
                                    <a rel="noreferrer" href="https://forluz.gupy.io/" target="_blank" className="btn btn-primary py-4 px-7 my-7 my-md-0 rounded d-flex align-items-center">
                                        <span className="ico mr-3">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.44444 0V1.55556H1.55556V12.4444H12.4444V8.55556H14V13.2222C14 13.4285 13.9181 13.6263 13.7722 13.7722C13.6263 13.9181 13.4285 14 13.2222 14H0.777778C0.571498 14 0.373667 13.9181 0.227806 13.7722C0.0819442 13.6263 0 13.4285 0 13.2222V0.777778C0 0.571498 0.0819442 0.373667 0.227806 0.227806C0.373667 0.0819442 0.571498 0 0.777778 0H5.44444ZM11.3447 1.55556H7.77778V0H14V6.22222H12.4444V2.65533L7 8.09978L5.90022 7L11.3447 1.55556Z" fill="white" />
                                            </svg>
                                        </span>
                                        <span>
                                            Trabalhe conosco
                                        </span>
                                    </a>
                                </div>
                            </div>

                            <div className="page-description__midias">
                                <PageDescriptionFootnote />
                            </div>

                            <div className="page-description__title mb-lg-5">
                                {item.Corpo &&
                                    <>
                                        <br></br><br></br>
                                        <span dangerouslySetInnerHTML={renderObjectBody(item.Corpo)} />
                                        <hr></hr> </>}
                            </div>
                        </div>
                    ))}


                </div>
            </div>
        </section>
    )
};
export default PageDescriptionAtracao;